import { ChangeDetectorRef, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import moment from "moment";
import { UtilsService } from "../../../../auth/service/utils.service";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { WorkdayReportService } from "../../workday-report.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-single-staff-report",
  templateUrl: "./single-staff-report.component.html",
  styleUrls: ["./single-staff-report.component.scss"]
})
export class SingleStaffReportComponent implements OnInit {
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();
  @ViewChild("tableHeader") tableHeader: ElementRef;
  public contentHeader: IContentHeader;
  public report: any = {}; // Sarà contenuto il report generato e anche quello caricato(sia dall'utente che da parte della visualizzazione dello staff
  public available_working_days: Array<number> = [];
  public totalWorkedHours: number = 0;
  public totalNotWorkedHours: number = 0;
  public totalExtraHours: number = 0;
  public totalExtraHours_km: number = 0;
  public totalExtraHours_payroll: number = 0;
  public rejectedNote: string = null;
  public daysOfTheMonth: any = [];
  public categoriesAbsencesList: any = [];
  public idReport: number = null; //Variabile valorizzata solo nel caso della modalità isStaffMode true
  public statusReport: number = -1;
  public statusNoteReport: string = "";
  public openedRow: string = "";
  public rowsWithErrorMissingHours: string[] = [];
  public commissionTotalHours: any = null;
  public commissionColors: any = {};
  public monthSelectedReport: any = null;

  constructor(
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    public _workdayReportService: WorkdayReportService,
    private activatedRoute: ActivatedRoute,
    public _routerService: Router,
    public _modalService: NgbModal,
    public _userService: UserService,
    private _changeDetectorRef: ChangeDetectorRef
  ) {
    this._utilService.disableAutoHideLoading();
    this.activatedRoute.params.subscribe(async (params) => {
      if (params.hasOwnProperty("id")) {
        //Se è presente un id entriamo in staffMode
        this.idReport = Number(params.id);
      } else {
        await this._routerService.navigateByUrl("/dashboard/workday-report/users-reports");
      }
    });
    this._utilService.disableAutoHideLoading();

    this.contentHeader = {
      headerTitle: "WORKDAY_REPORT_OF",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/"
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management"
          },
          {
            name: "MENU.WORKDAY_USERS_REPORTS",
            isLink: true,
            link: "/dashboard/workday-report/users-reports"
          },
          {
            name: "",
            isLink: false
          }
        ]
      }
    };
    // Parametro gestito da configurazione per i giorni lavorativi
    this.available_working_days = this._utilService.themeConfiguration.working_days;
  }

  async ngOnInit() {
    // carico il rapportino
    await this.loadReport();

    // prendo la lista delle tipologie di assenza
    this.categoriesAbsencesList = await this._workdayReportService.getCategoriesList();

    this._utilService.hideLoading();

    // gestione sticky table header
    if (this._utilService.isDesktop) {
      window.addEventListener("scroll", () => {
        if (window.scrollY >= 270) {
          if (!this.tableHeader.nativeElement.classList.contains("sticky")) {
            this.tableHeader.nativeElement.classList.add("sticky");
          }
        } else {
          this.tableHeader.nativeElement.classList.remove("sticky");
        }
      });
    }
  }

  private async loadReport() {
    const savedReport: any = await this._workdayReportService.get(this.idReport);

    if (savedReport === null) {
      await this._routerService.navigateByUrl("/dashboard/workday-report/users-reports");
      return false;
    }

    const headerTitle = await this._utilService.translate("WORKDAY_REPORT_OF");
    this.contentHeader.headerTitle = `${headerTitle} ${savedReport.complete_name}`;
    this.contentHeader.breadcrumb.links[3].name = `${headerTitle} ${savedReport.complete_name}`;

    this.statusReport = savedReport.status;
    this.statusNoteReport = savedReport.status_note;
    if (savedReport && savedReport.month && savedReport.year) {
      this.monthSelectedReport = moment()
        .month(savedReport.month - 1)
        .format("MMMM YYYY");
    }
    this.report = {};
    this.daysOfTheMonth = [];
    this.totalNotWorkedHours = 0;
    this.commissionTotalHours = {};
    for (const item of savedReport.data) {
      const day: string = moment(item.date, "YYYY-MM-D").format("YYYY-MM-DD");
      delete item.date;

      item.extra = 0;

      for (const comm of item.commissions) {
        if (comm.extra.type) {
          item.extra += comm.extra.hours || 0;
        }
        if (!this.commissionTotalHours.hasOwnProperty(`order${comm.order_id}`)) {
          this.commissionTotalHours[`order${comm.order_id}`] = {
            hours: 0,
            name: comm.client_name
          };
        }
        this.commissionTotalHours[`order${comm.order_id}`].hours += comm.worked;
      }

      // aggiungo gli extra dai costi di struttura
      for (const structure of item.structures) {
        if (structure.extra.type) {
          item.extra += structure.extra.hours || 0;
        }
      }

      if (this.isWorkDay(day)) {
        for (const ab of item.absences) {
          if (ab.code !== 9999) {
            this.totalNotWorkedHours += ab.hours;
          }
        }
      }

      this.report[day] = item;
      this.daysOfTheMonth.push(day);
    }
    //Sistema colori commesse, abbiamo cinque colori che si alternano
    let count: number = 0;
    for (const orderCommissionId of Object.keys(this.commissionTotalHours)) {
      count += 1;
      if (count > 5) {
        count = 1;
      }
      //Per ogni chiave assegno order+id che sarà univoco es order55, nel html andro a richiamarlo cosi da assegnare il colore al badge
      if (!this.commissionColors.hasOwnProperty(`${orderCommissionId}`)) {
        this.commissionColors[`${orderCommissionId}`] = {
          color: `color-${count}`
        };
      }
      this.commissionColors[`${orderCommissionId}`].color = `color-${count}`;
    }

    const configurationWorkingDays = this._utilService.themeConfiguration.working_days
    const working_days = this.daysOfTheMonth.filter((date: string) => {
      const day = moment(date);
      return configurationWorkingDays.includes(day.day()) && !this._utilService.isHoliday(day);
    });
    const last_working_day = working_days[working_days.length - 1];

    const reportMonth = moment(Object.keys(this.report)[0]);
    if (reportMonth.month() === moment().month()) {
      let days_with_commissions: string[] = [];
      for (const day of working_days) {
        const value = this.report[day];
        if (value.residual_hours === 0) {
          days_with_commissions.push(day);
        }
      }
      const last_day_with_commissions = days_with_commissions[days_with_commissions.length - 1];

      if (!last_day_with_commissions) {
        const reportMonth = Number(Object.keys(this.report)[0]?.split("-")[1] || moment().month() + 1);
        const day = moment(working_days[0]).set("month", reportMonth - 1).format("DD MMMM");
        const text = await this._utilService.translate("MISSING_COMMISSIONS_FOR_WORKING_DAY").then((text: string) => text.replace("DATA", day));
        this._utilService.hideLoading();
        await this._utilService.showSWALEmptyField({ text });
      } else if (last_working_day != last_day_with_commissions && last_day_with_commissions != moment().endOf("month").format("YYYY-MM-DD")) {
        const day = moment(last_day_with_commissions).format("DD MMMM");
        const text = await this._utilService.translate("MISSING_COMMISSIONS_FOR_WORKING_DAY").then((text: string) => text.replace("DATA", day));
        await this._utilService.showSWALEmptyField({ text });
      }
    }

    this.totalExtraHours = savedReport.extra_hours;
    this.totalWorkedHours = savedReport.worked_hours;

    for (const d of Object.keys(this.report)) {
      for (const comm of this.report[d].commissions) {
        comm.extra.hours_km = parseFloat(comm.extra.hours_km || 0);
        comm.extra.hours_payroll = parseFloat(comm.extra.hours_payroll || 0);
        this.totalExtraHours_km += comm.extra.hours_km;
        this.totalExtraHours_payroll += comm.extra.hours_payroll;
      }
    }
  }

  //Funzione per gestire i colori della visualizzazione della lista
  isWorkDay(day: string) {
    const dayN: number = Number(moment(day).format("d"));
    return this.available_working_days.includes(dayN);
  }

  getDayRowClasses(day: string) {
    let classes: string[] = [];

    if (this.isWorkDay(day)) {
      if (this._utilService.isHoliday(day)) {
        classes.push("holiday");
      } else {
        classes.push("work");
      }
    } else {
      classes.push("off");
    }

    if (this.rowsWithErrorMissingHours.includes(day)) {
      classes.push("bg-light-danger");
    }

    return classes.join(" ");
  }

  openRow(day: string) {
    const newValue: string = day === this.openedRow ? "" : day;

    if (newValue !== "" && this.report[newValue].extra < 0) {
      return false;
    }

    if (newValue !== this.openedRow && this.openedRow !== "") {
      if (this.hasResidueHours(this.openedRow)) {
        this.rowsWithErrorMissingHours.push(this.openedRow);
      } else {
        this.rowsWithErrorMissingHours = this.rowsWithErrorMissingHours.filter((d) => d !== this.openedRow);
      }
    }

    this.openedRow = newValue;
  }

  private hasResidueHours(day: string) {
    let sumHours: number = 0;
    let totalHours: number = 0;
    const selectedDay: any = this.report[day];
    for (const comm of selectedDay.commissions) {
      comm.extra.hours_km = parseFloat(comm.extra.hours_km || 0);
      comm.extra.hours_payroll = parseFloat(comm.extra.hours_payroll || 0);
      this.totalExtraHours_km += comm.extra.hours_km;
      this.totalExtraHours_payroll += comm.extra.hours_payroll;
      sumHours += comm.extra.hours_km + comm.extra.hours_payroll;
      totalHours += comm.extra.hours as number;
    }
    for (const structure of selectedDay.structures) {
      structure.extra.hours_km = parseFloat(structure.extra.hours_km || 0);
      structure.extra.hours_payroll = parseFloat(structure.extra.hours_payroll || 0);
      this.totalExtraHours_km += structure.extra.hours_km;
      this.totalExtraHours_payroll += structure.extra.hours_payroll;
      sumHours += structure.extra.hours_km + structure.extra.hours_payroll;
      totalHours += structure.extra.hours as number;
    }
    return sumHours < totalHours;
  }

  setExtra(day: any, commissionIndex: number, type: string, field: string = "commissions") {
    const commExtra: any = this.report[day][field][commissionIndex].extra;
    if (commExtra.hours_km + commExtra.hours_payroll > commExtra.hours) {
      if (type === "km") {
        commExtra.hours_km = commExtra.hours - commExtra.hours_payroll;
      } else {
        commExtra.hours_payroll = commExtra.hours - commExtra.hours_km;
      }
    }
    this._changeDetectorRef.detectChanges();
  }

  toInt($event: any) {
    $event.target.value = Number($event.target.value);
    const max = Number($event.target.max);
    if (max < $event.target.value) {
      $event.target.value = max;
    }
  }

  //Funzione apertura modale per inserire la nota del rifiuto
  showRejectModal(modal: any) {
    this._modalService.open(modal, {
      centered: true,
      size: "sm"
    });
    this.rejectedNote = "";
  }

  /**
   * funzione per l'invio del rapportino
   */
  async update() {
    // chiudo automaticamente la riga aperta
    this.openRow("");

    // se c'è qualche errore esco dalla funzione
    if (this.rowsWithErrorMissingHours.length > 0) {
      await this._utilService.showSWALError({ text: "YOU_FORGOT_SOME_HOURS_IN_YOUR_REPORT" });
      return false;
    }

    this._utilService.showLoading();
    await this._workdayReportService
      .update(this.idReport, {
        report: this.report,
        status: 2
      })
      .then(async () => {
        await this.loadReport();
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_UPDATE_WORKDAY_REPORT" });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_UPDATE_WORKDAY_REPORT" });
      });
  }

  //Funzione per rifiutare un rapportino
  async reject() {
    if (!this._authenticationService.hasCapability("edit_workday_report_status")) {
      window.history.back();
      return false;
    }
    this._utilService.showLoading();

    await this._workdayReportService
      .updateStatus("reject", {
        report_id: this.idReport,
        status_note: this.rejectedNote
      })
      .then(async () => {
        this._modalService.dismissAll();
        this.rejectedNote = "";
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_REJECT_WORKDAY_REPORT" });
        await this._routerService.navigateByUrl("/dashboard/workday-report/users-reports");
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_REJECT_WORKDAY_REPORT" });
      });
  }

  protected readonly Object = Object;
}
